import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewChild, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { NgOtpInputComponent, NgOtpInputConfig, NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'portal-form-otp-input',
  standalone: true,
  imports: [NgIf, NgOtpInputModule],
  templateUrl: './otp-input.component.html',
  styles: [':host {@apply block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => OtpInputComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: OtpInputComponent,
    },
  ],
})
export class OtpInputComponent implements ControlValueAccessor, Validator {
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput?: NgOtpInputComponent;

  @Input() formControlName?: string;
  @Input() formControl?: FormControl;
  @Input() label = '';
  @Input() required = true;
  @Input() config: NgOtpInputConfig = { length: 6 };
  @Input() disabled = false;

  onChange: (value: unknown) => void = () => {};
  onTouched = () => {};

  writeValue(obj: string | null): void {
    this.ngOtpInput?.setValue(obj ? obj : '');
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.required = this.hasRequiredValidator(control);
    if (this.required && control.value === null) {
      return { required: true };
    }
    return null;
  }

  onInputChange(value: string) {
    this.onChange(value);
    this.onTouched();
  }

  private hasRequiredValidator(control: AbstractControl): boolean {
    if (control.validator) {
      const validator = control.validator({} as AbstractControl);
      if (validator && validator['required']) {
        return true;
      }
    }
    return false;
  }
}
